import Information from './Information'
import Setting from './Setting'

const BareMetalServer = {
    Information,
    Setting,
}

export default BareMetalServer
